module.exports = __webpack_public_path__ + "img/7.bc900737.jpg";